import axios from 'axios'
export default axios.create({
    baseURL: 'https://qnybvn8bae.execute-api.us-east-1.amazonaws.com'
})